export class NumberSerializer {
  serialize(arg) {
    return arg;
  }

  deserialize(arg) {
    return arg;
  }

}